export const CONTENT_SCOPE_CHANGED = "CONTENT_SCOPE_CHANGED";

export const contentScopeChangedAction = (userScope) => ({
	type: CONTENT_SCOPE_CHANGED,
	userScope: String(userScope || "guest"),
});
